import {Component, Output, Input, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import { ProjectNavigationState } from '../../model/project-navigation-state';
import { Project } from '../../model/project';
import {Terminal} from '../../model/terminal';
import {Questionnaire} from '../../model/questionnaire';
import {SharedRefreshService} from '../../service/sharedRefreshService';


@Component({
    selector: 'project-navbar',
    template: `
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <button style="margin-right: 10px;" class="btn btn-primary" id="menu-toggle"><span class="fas fa-bars"></span></button>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse"  id="navbarSupportedContent">
          <ul class="navbar-nav">
            <!--<li [class.active]="navigationState.selectedView == 'info'">
              <a class="hand" (click)="onNavbarClick('info')">{{'Infos'|translate}}</a>
              <div></div>
            </li>-->
              <li class="nav-item">
                  <button class="btn btn-outline-warning my-2 my-sm-0" [class.active]="navigationState.selectedView == 'home'" (click)="onNavbarClick('home')"><img alt="homeIcon" class="homeIcon" src="../../../assets/images/259.png"></button>
                  <div></div>
              </li>
            <button style="margin-right: 10px;" type="button"  [class.active]="navigationState.selectedView == 'info'" class="info btn btn-outline-success my-2 my-sm-0" (click)="onNavbarClick('info')">{{'Infos'|translate}}</button>
            <div class="dropdown">
              <button class="btn btn-primary dropdown-toggle dropdownQuestionnaire" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Questionnaires
              </button>
                <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu">
                  <li *ngFor="let questionnaire of project.questionnaires" [class]="questionnaire.terminals.length>0?'dropdown-submenu':'dropdown-item2'" >
                    <a class="dropdown-item" tabindex="-1" title="{{questionnaire.name}}" (click)="onQuestionnaireClick(questionnaire)">{{getName(questionnaire.name)}}</a>
                    <ul *ngIf="questionnaire.terminals.length>0" class="dropdown-menu">
                      <li class="dropdown-item2" *ngFor="let terminal of questionnaire.terminals"><a  class="dropdown-item" tabindex="-1" title="{{terminal.name}}" (click)="onTerminalClick(terminal)">{{getName(terminal.name)}}</a></li>
                    </ul>
                  </li>
                  <li class="divider"></li>
                  <li>
                    <span class="dropdown-item hand" (click)="onCreateQuestionnaireClick()">{{'new'|translate}}</span>
                  </li>
                </ul>
            </div>
            <!--<ul class="navbar-nav mr-auto">
              <li class="nav-item dropdown" style="margin-right:10px;" [class.active]="navigationState.selectedView == 'questionnaires'">
                <div class="dropdown">
                  <button type="button" id="dropdownMenuButton" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{'Questionnaires'|translate}}
                  </button>
                    <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu">
                      <li *ngFor="let questionnaire of project.questionnaires" class="dropdown-submenu" >
                        <span class="dropdown-item dropdown-toggle" data-toggle="dropdown" title="{{questionnaire.name}}" (click)="onQuestionnaireClick(questionnaire)">{{questionnaire.name.substr(0,20)}}...</span>
                        <ul class="dropdown-menu">
                          <li  *ngFor="let terminal of questionnaire.terminals"><span class="dropdown-item" tabindex="-1" title="{{terminal.name}}" (click)="onTerminalClick(terminal)">{{terminal.name.substr(0,20)}}...</span></li>
                        </ul>
                      </li>
                      <li class="divider"></li>
                      <li>
                        <span class="dropdown-item hand" (click)="onCreateQuestionnaireClick()">{{'new'|translate}}</span>
                      </li>
                    </ul>
                </div>
              </li>
            </ul>-->

            <!--<ul *ngIf="navigationState.selectedView == 'questionnaires'" class="navbar-nav mr-auto">
              <li class="nav-item dropdown" style="margin-right:10px;" [class.active]="navigationState.selectedView == 'terminal'">
                <div class="btn-group">
                  <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{'Terminal'|translate}}
                  </button>
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item hand" *ngFor="let terminal of terminals" (click)="onTerminalClick(terminal)">{{terminal.name}}</a>
                    <a class="dropdown-item hand" (click)="onCreateTerminalClick()">{{'new'|translate}}</a>
                  </div>
                </div>
              </li>
            </ul>-->
          </ul>
        </div>
      </nav>`,
  styles:[`

      .homeIcon{height:35px;}
      .icon{height:25px;}
      .btn-outline-warning{padding: 0;}
      .info,.dropdownQuestionnaire{height:37px;}

    .dropdown-submenu {
    position: relative;
  }
    .dropdown-menu{width:230px;}

    .dropdown-item{
      font-family: Helvetica;
      font-weight: bold;
      font-size:13px;}

    .dropdown-menu .dropdown-item:hover {
      background: -webkit-linear-gradient(top, #648bf5, #2866f2);
      background: linear-gradient(to bottom, #648bf5 0%, #2866f2 100%);
      border-top: 1px solid #5a82eb;
      border-bottom: 1px solid #1758e7;
      color: #ffffff;
    }
  .dropdown-submenu>.dropdown-menu {
    top: 0;
    left: 100%;
    margin-top: -6px;
    margin-left: -1px;
    -webkit-border-radius: 0 6px 6px 6px;
    -moz-border-radius: 0 6px 6px;
    border-radius: 0 6px 6px 6px;
  }

  .dropdown-submenu:hover>.dropdown-menu {
    display: block;
  }

  .dropdown-submenu>a:after {
    display: block;
    content: " ";
    float: right;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 5px 0 5px 5px;
    border-left-color: #000;
    margin-top: 5px;
    margin-right: -10px;
  }

  .dropdown-submenu:hover>a:after {
    border-left-color: #000;
  }

  .dropdown-submenu.pull-left {
    float: none;
  }

  .dropdown-submenu.pull-left>.dropdown-menu {
    left: -100%;
    margin-left: 10px;
    -webkit-border-radius: 6px 0 6px 6px;
    -moz-border-radius: 6px 0 6px 6px;
    border-radius: 6px 0 6px 6px;
  }`]
})
export class ProjectNavbarComponent implements OnChanges {
    @Input('navigation') navigationState: ProjectNavigationState;
    @Input('project') project: Project;
    @Output() CreateQuestionnaire: EventEmitter<any> = new EventEmitter();
    @Output() CreateTerminal: EventEmitter<any> = new EventEmitter(); // a retirer
    @Output() QuestionnaireSelected: EventEmitter<Questionnaire> = new EventEmitter();
    @Output() TerminalSelected: EventEmitter<Terminal> = new EventEmitter(); // a retirer


    private terminals: Terminal[] = [];

    constructor(private _refreshService:SharedRefreshService) {

    }

    /*ngOnInit():void
    {
        for(let questionnaireProject of this.project.questionnaires) {
            //for(let terminal of questionnaireProject.terminals)
            this.terminals.concat(questionnaireProject.terminals);
            //this.terminals.push(terminal);
        }
    }*/

    onCreateQuestionnaireClick() {
        this.CreateQuestionnaire.emit();
    }

    onCreateTerminalClick() {
        this.CreateTerminal.emit();
    }


    onQuestionnaireClick(questionnaire:Questionnaire) {
        this.QuestionnaireSelected.emit(questionnaire);
        this.terminals = questionnaire.terminals;
    }

    onTerminalClick(terminal:Terminal) {
        this.TerminalSelected.emit(terminal);
    }

    onNavbarClick(value) {
        this.navigationState.selectedView = value;

        if(value==='home') {
            this._refreshService.refresh(true);
        }
    }

    // the fix is to use this as an input property and call the lifeCycle ngOnChange() Method
    updateNavbarContent(questionnaireArr: Questionnaire[]) {
        this.project.questionnaires = questionnaireArr;
        this.terminals = [];
        for (const questionnaire of questionnaireArr) {
            // for(let terminal of questionnaireProject.terminals)
            this.terminals = this.terminals.concat(questionnaire.terminals);
            // this.terminals.push(terminal);
        }
    }

  ngOnChanges(changes: SimpleChanges): void {
      console.log(changes);
      this.terminals = [];
      for (const quest of this.project.questionnaires) {
        // for(let terminal of questionnaireProject.terminals)
        this.terminals = this.terminals.concat(quest.terminals);
        // this.terminals.push(terminal);
      }
  }


  private  getName(name: string):string {
    if(name.length>20) {
      return name.substr(0,20)+'...';
    }
    return name;
  }
}
